import { Flex } from '@frontend/components';

const CellContainer = ({
  big,
  dim,
  dark,
  editable,
  edited,
  children,
  ...rest
}) => (
  <Flex
    role="gridcell"
    justifyContent="center"
    borderLeft="1px solid"
    borderColor="separator.divider"
    fontFamily="data"
    fontSize="md"
    pr={2}
    pl={0.25}
    h="100%"
    w={big ? '165px' : '140px'}
    textAlign="right"
    fontWeight="heavy"
    color={editable ? '#1B6AF6' : dim ? 'page.plateMedium' : 'feature.primary'}
    bg={edited ? '#FFEEB6' : dark ? 'page.plateLight' : 'page.surface'}
    flexFlow="column"
    position="relative"
    {...rest}
  >
    {children}
  </Flex>
);

export default CellContainer;
